import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=7e7155f2&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7155f2",
  null
  
)

export default component.exports